<template lang="pug">
  .dashboard.animated.fadeIn
    WtTile(ancestor vertical)
      WellnessChallengeQuestionsNotification
      WtTile(v-if="showWelcomeCard" parent vertical).i
        WtTile.is-paddingless(child :col="12")
          BNotification(
            type="is-lightgrey"
            aria-close-label="Close welcome message"
            @close="closeWelcomeMessage"
          ) {{welcomeText}}
      WtTile(v-if="migrationNotice && migrationNotice.length" parent vertical)
        WtTile.is-paddingless(child :col="12")
          BNotification(
            type="is-lightgrey"
            aria-close-label="Close notice"
            :closable="false"
          )
            WtButton.fake-close-button(@click.native="dismiss(migrationNotice[0].id)")
              BIcon(icon="close" size="is-small")
            WtDisplayRichTextHTML(:html="migrationNotice[0].text")
      WtTile(v-for="notice in memberNotices" parent vertical :key="notice.id")
        WtTile.is-paddingless(child :col="12")
          BNotification(
            type="is-lightgrey"
            aria-close-label="Close notice"
            :closable="false"
          )
            WtButton.fake-close-button(@click.native="dismiss(notice.id)")
              BIcon(icon="close" size="is-small")
            WtDisplayRichTextHTML(:html="notice.text")
      WtTile(v-if="displayMissingAnswersNotification" parent vertical).i
        WtTile.is-paddingless(child :col="12")
          BNotification(
            type="is-lightgrey"
            aria-close-label="Close welcome message"
            :closable="false"
          ) You have unanswered questions.{{' '}}
            WtRouterLink.has-text-primary(
              to="MemberQuestionsUnanswered"
            ) Answer now.
      WtTile(parent)
        WtTile(child child-class="")
          .level.my-dashboard-header
            .level-left
              .level-item
                WtTitle(h1) My Dashboard
            .level-right
              .level-left
                .level-item.m-4
                  ConnectDevice(:data="$auth.user()")
              .level-right
                .level-item
                  MakeAnEntry
      WtTile
        WtTile(vertical :col="8")
          WtTile
            WtTile(parent :col="6")
              WtTile(child :is-loading="_.isEmpty($auth.user())")
                UserCard(:data="$auth.user()")
            WtTile(parent :col="6")
              WtTile(child :col="12")
                TodaysProgress
          WtTile(parent :col="12")
            WtTile(child :col="12" :is-loading="!stepDataLoaded" is-syncing)
              DashboardChart
          WtTile(parent v-if="coreProgramMeta.allowJournals")
            WtTile(child :is-loading="!journalsLoaded" is-syncing)
              Journal(
                title="My Journal Entries"
                :journal-entry-stats="journalEntryStats"
                :is-last-page="isJournalLastPage"
                :journal-data="journals"
                :fetch-action="fetchJournals"
              )

        WtTile(vertical :col="4")
          WtTile(parent v-if="showAssessmentWidget")
            WtTile(child :col="12")
              DashboardAssessmentWidget
          WtTile(parent v-if="showRedeemPoints")
            WtTile(child :col="12")
              DashboardRedeemAwardPoints
          WtTile(parent)
            WtTile(child :col="12" :is-loading="_.isEmpty($auth.user())")
              WtEntityList(
                entityType="challenge"
                :data="validMemberChallenges"
                title="Challenges"
                to="Challenges"
                :body-heading="`Challenges (${validMemberChallenges.length})`"
                hasFeatured
              )
                span(slot="featuredTitle") Featured {{validFeaturedChallenges.length ? `(${validFeaturedChallenges.length})` : ""}}
                BCarousel#dashboard-featured-challenges-carousel(
                  v-if="validFeaturedChallenges.length"
                  slot="featured"
                  :autoplay="false"
                  :arrow="true"
                  :arrow-hover="false"
                  :indicator="false"
                )
                  BCarouselItem(
                    v-for="(featuredChallenge, i) in validFeaturedChallenges"
                    :key="i"
                  )
                    FeaturedChallengeForWtEntityList(
                      :featured-challenge="featuredChallenge"
                    )
                FeaturedChallengeForWtEntityList(
                  v-else
                  slot="featured"
                  :featured-challenge="{}"
                )
          WtTile(parent)
            WtTile(child :col="12" :is-loading="_.isEmpty($auth.user())")
              MemberActivityOverview(:data="_.isEmpty(member) ? _.get($auth.user(), 'memberData', {}) : member.memberData")
          .is-sticky-on-scroll
            WtTile(parent v-if="$auth.user().program.hraEnabled")
              WtTile(child :col="12")
                DashboardHra
            WtTile(parent)
              WtTile(
                child
                :col="12"
                :is-loading="!friendsLoaded"
                is-syncing
              )
                EmptyEntityPlaceholder(
                  v-if="_.isEmpty(memberFriends)"
                  :image="require('@/assets/placeholders/empty_friends.jpg')"
                  title="My Friends"
                  callout=""
                  buttonText="Discover New Friends"
                  to="Friends"
                )
                MyDashboardMyFriends(
                  v-else
                  :data="memberFriends"
                  :username="$auth.user().username"
                )
            //- [TEAMS FEATURE]
            WtTile(parent v-if="isTeamsFeatureOn")
              WtTile(child :is-loading="_.isEmpty($auth.user())")
                EmptyEntityPlaceholder.custom-styled(
                  v-if="_.isEmpty(teamData)"
                  :image="require('@/assets/placeholders/empty_team.jpg')"
                  title="My Team"
                  callout="You haven't joined a team yet. Join one today!"
                  textBackground
                  buttonText="View Teams"
                  to="Teams"
                )
                MyTeam(
                  v-else
                  :team="teamData"
                )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";
import MemberActivityOverview from "@@/Members/MemberActivityOverview";
import TodaysProgress from "@@/Members/TodaysProgress/TodaysProgress";
import UserCard from "@@/Members/UserCard";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtEntityList from "@@/WtEntityList/WtEntityList";
import WtStatRow from "@@/WtStatRow/WtStatRow";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import MyDashboardMyFriends from "@@/Friends/MyDashboardMyFriends";
import DashboardChart from "@@/Members/DashboardChart";
import Journal from "@@/Members/Journal";
import MakeAnEntry from "@@/Members/MakeAnEntry/MakeAnEntry";
import ConnectDevice from "@@/Members/ConnectDevice.vue";
import WellnessChallengeQuestionsNotification from "@@/Challenge/WellnessChallenge/WellnessChallengeQuestionsNotification";
import MyTeam from "@@/Teams/MyTeam";
import DashboardHra from "@@/Members/DashboardHra.vue";
import DashboardAssessmentWidget from "@@/Companion/DashboardAssessmentWidget.vue";
import DashboardRedeemAwardPoints from "@@/Members/DashboardRedeemAwardPoints.vue";
import programMixin from "@/mixins/programMixin";
import { challengeMixin } from "@/mixins/challengeMixin";

const FeaturedChallengeForWtEntityList = () =>
  import(
    /* webpackChunkName: "FeaturedChallengeForWtEntityList" */ "@@/Challenges/FeaturedChallengeForWtEntityList"
  ).catch(() => {
    window.location.reload();
  });
const EmptyEntityPlaceholder = () =>
  import(
    /* webpackChunkName: "EmptyEntityPlaceholder" */ "@@/EmptyEntityPlaceholder"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "MyDashboard",

  components: {
    MemberActivityOverview,
    TodaysProgress,
    UserCard,
    WtButton,
    WtEntityList,
    WtRouterLink,
    WtStatRow,
    WtTile,
    WtTitle,
    WtDisplayRichTextHTML,
    MyDashboardMyFriends,
    DashboardChart,
    DashboardHra,
    DashboardRedeemAwardPoints,
    DashboardAssessmentWidget,
    Journal,
    FeaturedChallengeForWtEntityList,
    EmptyEntityPlaceholder,
    MakeAnEntry,
    ConnectDevice,
    MyTeam,
    WellnessChallengeQuestionsNotification
  },

  mixins: [fetchAllMixin, programMixin, challengeMixin],

  data() {
    return {
      page: `MyDashboard`,
      welcomeMessageClosed: false,
      migrationNotice: null
    };
  },

  computed: {
    ...mapGetters("authMember", ["emailNotConfirmed", "passwordChanged"]),
    ...mapGetters("program", [
      "programLoaded",
      "coreProgramMeta",
      "featuredChallenge",
      "currentFeaturedChallengeLoaded",
      "isTeamsFeatureOn",
      "isProTier",
      "featuredChallenges"
    ]),
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("members", [
      "challenges",
      "challengesLoaded",
      "member",
      "memberLoaded",
      "memberTeams",
      "memberTeamsLoaded",
      "getLeaderboardByMemberId",
      "leaderboardLoaded",
      "stepDataLoaded",
      "stepData",
      "journals",
      "journalEntryStats",
      "journalsLoaded",
      "isJournalLastPage",
      "memberNotice",
      "memberNoticeLoaded",
      "memberFriends",
      "friendsLoaded"
    ]),
    ...mapGetters(["members/challengeInvites"]),

    fullPageLoader() {
      // since there is no initial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    },

    showWelcomeCard() {
      return (
        this.member.showWelcomeFlow &&
        this.coreProgramMeta.welcomeText &&
        !this.welcomeMessageClosed
      );
    },

    showRedeemPoints() {
      return this.doesProgramHaveFeature(
        this.$auth.user().program.terryberryCompanyFeatures,
        "Grs"
      );
    },
    showAssessmentWidget() {
      return this.$auth.user().program.mentalWellnessEnabled;
    },

    welcomeText() {
      return this.sanitize(this.coreProgramMeta.welcomeText, {
        allowedTags: [],
        allowedAttributes: {}
      });
    },

    memberNotices() {
      if (!this.memberNotice) return [];
      return this.memberNotice.filter(notice => {
        return (
          this.moment(notice.begins).isBefore(this.moment()) ||
          this.moment().isAfter(this.moment(notice.expires))
        );
      });
    },

    challengesCount() {
      return !this.challengesLoaded &&
        this._.has(this.$auth.user(), "challenges")
        ? this.$auth.user().challenges.length
        : this.challenges.length;
    },

    teamData() {
      return this._.isEmpty(this.memberTeams) &&
        this._.has(this.$auth.user(), "teams")
        ? this.$auth.user().teams[0]
        : this.memberTeams[0];
    },

    displayMissingAnswersNotification() {
      // only for thrive tier
      if (!this.isProTier) {
        return false;
      }

      return (
        this.member.unansweredQuestions &&
        this.member.unansweredQuestions.length
      );
    },

    // check that challenge is public or member is invited and challenge didn't end
    validFeaturedChallenges() {
      return this.featuredChallenges.filter(challenge => {
        return (
          (this.isPublic(challenge) ||
            (!this.isPublic(challenge) && this.isInvited(challenge))) &&
          !this.isTodayAfterChallengeEnd(challenge)
        );
      });
    },

    // check that challenges didn't end
    validMemberChallenges() {
      let userChallenges =
        !this.challengesLoaded && this._.has(this.$auth.user(), "challenges")
          ? this.$auth.user().challenges
          : this.challenges;
      return userChallenges.filter(challenge => {
        return !this.isTodayAfterChallengeEnd(challenge);
      });
    }
  },

  mounted() {
    if (this.passwordChanged) {
      this.snackBar({
        duration: 10000,
        message:
          "Your password has been changed. You may use your new password to login from now on."
      });

      this["authMember/setPasswordChanged"](false);
    }

    const memberId = this.$auth.user().id;

    if (localStorage[`welcomeMessageClosed${memberId}`]) {
      this.welcomeMessageClosed = true;
    }

    // Temp migration script welcome to new-ui notice.
    this.axios
      .get(`members/${memberId}/notices`, {
        params: { type: "migration" }
      })
      .then(response => {
        this.migrationNotice = response.data.data;
      });
  },

  methods: {
    ...mapActions("pages", [
      "setPageLoaded",
      "setPageLoading",
      "fetchAllPageMyDashboard"
    ]),
    ...mapActions([
      // [TEAMS FEATURE]
      "members/fetchMemberTeams",
      "snackBar",
      "authMember/setPasswordChanged",
      "members/fetchJournals",
      "members/fetchMessages"
    ]),
    ...mapActions("notices", ["dismissNotice"]),

    fetchJournals(
      photosOnly = false,
      friends = false,
      page = null,
      resetList = false
    ) {
      return this["members/fetchJournals"]({
        memberId: this.$auth.user().id,
        isProfile: false,
        photosOnly,
        friends,
        page,
        resetList
      });
    },

    async fetchAllPage(vm) {
      const member = vm.$auth.user();

      await vm.fetchAllPageMyDashboard(member);
    },

    dismiss(noticeId) {
      this.dismissNotice(noticeId);
    },

    closeWelcomeMessage() {
      // using localStorage for this because message is only temporary anyway (goes away on its own after 2 logins)
      localStorage[`welcomeMessageClosed${this.member.id}`] = true;
    },

    isPublic(challenge) {
      return challenge.public === 1;
    },

    isInvited(challenge) {
      const memberInviteIds = this["members/challengeInvites"].map(
        invite => invite.inviteId
      );

      return (
        memberInviteIds.includes(challenge.id) ||
        this.$auth.user().id === challenge.initiator.id
      );
    }
  },

  beforeRouteEnter(to, _, next) {
    next(async vm => {
      await vm.toFetchOrNotToFetch(vm, to.name);
    });
  }
};
</script>

<style lang="sass" scoped>
.custom-styled /deep/ .callout-text span
  font-size: 1.12rem
  background: rgba(0, 0, 0, 0.45)
.fake-close-button
  background-color: $grey
  border-radius: 50%
  width: 20px
  height: 20px
  padding: 2px 0 0 0
  position: absolute
  top: 10px
  right: 10px
#dashboard-featured-challenges-carousel
  /deep/ .carousel-items
    padding-top: 28px
    +mobile
      padding-top: 48px
  /deep/ .carousel-arrow
    width: 58px !important
    height: 24px
    position: absolute
    top: 0
    right: 0
    +mobile
      height: 40px
      width: 100px !important
    .icon
      background-color: $grey-dark
      color: $white
      position: absolute
      +mobile
        width: 40px
        height: 40px
    .icon.has-icons-left
      left: 0
    .icon.has-icons-right
      right: 0
</style>
